import { StyleSheet, View } from 'react-native';

import { Skeleton } from 'components/ui/skeleton';
import { primitive } from 'styles/constants';

export const LoyaltySkeletonRewardCard = () => {
  return (
    <View style={styles.container}>
      <Skeleton shape="square" style={{ width: 72, height: 72 }} />
      <Skeleton shape="rectangle" style={{ width: 90, height: 16 }} />
      <Skeleton shape="circle" style={{ width: 44, height: 44 }} />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    width: 150,
    height: 200,
    borderWidth: 1,
    borderColor: primitive.$blackOpacity10,
    borderRadius: 10,
    alignItems: 'center',
    justifyContent: 'center',
    padding: 20,
  },
});
